
import {defineComponent} from "vue";
import {CbStructureMixin} from "@/components/layouts/content-pages/wysiwyg/structures/CbStructureMixin";
import {NormalContentBlockRestService} from "@/services/rest/cms-content-block/NormalContentBlockRestService";
import {FindNormalContentBlockPayload} from "@/models/payload/FindNormalContentBlockPayload";
import {CreateNormalContentBlockPayload} from "@/models/payload/CreateNormalContentBlockPayload";
import {SaveNormalContentBlockPayload} from "@/models/payload/SaveNormalContentBlockPayload";
import {CodeDescriptionRestDto} from "@/api/pharma-cms-content-block/models";
import {TeamInfoContentRestDtoModel} from "@/models/TeamInfoContentRestDtoModel";
import {DpException} from "@/exception/DpException";
import {PharmacyInformationRestService} from "@/services/rest/cms-pharmacy/PharmacyInformationRestService";
import BaseSpinner from "@/components/UI/Bootstrap/BaseSpinner.vue";
import InputSelect from "@/components/UI/InputSelect.vue";
import InputCheckboxBoolean from "@/components/UI/InputCheckboxBoolean.vue";

export default defineComponent({
  name: "CbTeamInfo",
  components: {InputCheckboxBoolean, InputSelect, BaseSpinner},
  extends: CbStructureMixin,
  data: () => ({
    contentBlock: TeamInfoContentRestDtoModel.createWithDefaults(),
    pharmacyOptions: [] as CodeDescriptionRestDto[]
  }),
  methods: {
    async find(payload: FindNormalContentBlockPayload): Promise<TeamInfoContentRestDtoModel> {
      return await NormalContentBlockRestService.getInstance().findTeamInfo(payload.type, payload.id);
    },
    async create(payload: CreateNormalContentBlockPayload): Promise<string> {
      return await NormalContentBlockRestService.getInstance().createTeamInfo(payload.cb as TeamInfoContentRestDtoModel, payload.type);
    },
    async save(payload: SaveNormalContentBlockPayload): Promise<void> {
      await NormalContentBlockRestService.getInstance().saveTeamInfo(payload.cb as TeamInfoContentRestDtoModel, payload.type, payload.id);
    },
    async afterReloadContent(): Promise<void> {
      await this.findPharmacies();

      if (!this.contentBlock.pharmacy_code) {
        this.contentBlock.pharmacy_code = this.pharmacyOptions[0].code;
      }
    },
    beforeSubmitData() {
      if (!this.contentBlock.pharmacy_code) {
        throw [new DpException(this.$t('Pharmacy needs to be selected.'))]
      }
    },
    getDefaultCbModel(): TeamInfoContentRestDtoModel {
      return TeamInfoContentRestDtoModel.createWithDefaults();
    },
    async findPharmacies(): Promise<void> {
      try {
        this.pharmacyOptions = await PharmacyInformationRestService
          .getInstance()
          .findPharmacies(true);
      } catch (exceptions: any) {
        this.setExceptions(exceptions);
      }
    },
    pasteCbMetadata(): void {
      this.contentBlock.cloneMetadataFrom(this.getClipboardContentBlock(this.cbType) as TeamInfoContentRestDtoModel);
    },
  }
});
